import { Autocomplete, Grid, Skeleton, Stack, TextField, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { dictionaryService, DictionaryName } from '../services/dictionaryService';
import { useEffect, useState } from 'react';
import { FormValues } from '../FormPagePerson';
import { useLanguage } from '../i18n/LanguageContext';

const ContactData = ({ formik }: { formik: FormikProps<FormValues> }) => {
    const { values, handleChange, handleBlur, errors, touched, setFieldValue } = formik;
    const { t } = useLanguage();
    const [voivodeshipsOptions, setVoivodeshipsOptions] = useState<DictionaryName[]>([]);
    const [countiesOptions, setCountiesOptions] = useState<DictionaryName[]>([]);
    const [municipalitiesOptions, setMunicipalitiesOptions] = useState<DictionaryName[]>([]);
    const [loadingVoivodeships, setLoadingVoivodeships] = useState(true);
    const [loadingCounties, setLoadingCounties] = useState(false);
    const [loadingMunicipalities, setLoadingMunicipalities] = useState(false);
    const [voivodeshipsCode, setVoivodeshipCode] = useState<string | undefined>(undefined);
    const [countiesCode, setCountiesCode] = useState<string | undefined>(undefined);



    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await dictionaryService.getVoivodeships();
                setVoivodeshipsOptions(data);
            } catch (error) {
                // Dictionary loading error handled silently
            } finally {
                setLoadingVoivodeships(false);
            }
        };

        fetchData();
    }, []);


    useEffect(() => {
        const fetchCounties = async () => {
            try {
                setLoadingCounties(true);
                let data;
                if (voivodeshipsCode) {
                    data = await dictionaryService.getCounties(voivodeshipsCode);
                    setCountiesOptions(data);
                }
            } catch (error) {
                // Loading error handled silently
            } finally {
                setLoadingCounties(false); // <--- TU TEŻ MA BYĆ FALSE (nie true!)
            }
        }
        fetchCounties();
    }, [voivodeshipsCode]); // <--- TU NASŁUCHUJEMY PROVINC

    useEffect(() => {
        const fetchCounties = async () => {
            try {
                setLoadingMunicipalities(true);
                let data;
                if (countiesCode && voivodeshipsCode) {
                    data = await dictionaryService.getMunicipalities(voivodeshipsCode, countiesCode);
                    setMunicipalitiesOptions(data);
                }
            } catch (error) {
                // Loading error handled silently
            } finally {
                setLoadingMunicipalities(false); // <--- TU TEŻ MA BYĆ FALSE (nie true!)
            }
        }
        fetchCounties();
    }, [countiesCode, voivodeshipsCode]); // <--- TU NASŁUCHUJEMY PROVINC

    return (
        <Grid container spacing={6} alignItems="flex-start" direction={{ xs: 'column', sm: 'row' }} sx={{marginTop: '60px' }}>
            <Grid size={{ xs: 12, sm: 12, md: 5 }} sx={{ height: 'auto' }}>
                <Typography variant="h6" sx={{ margin: 0, padding: '0px' }}>
                    {t('section.residentialAddress1')} <br />{t('section.residentialAddress2')}
                </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 7 }} >
                <Stack>
                    <Grid container spacing={4} direction={{ xs: 'column', sm: 'row' }}>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            {loadingVoivodeships ? (
                                <Skeleton variant="rectangular" height={56} />
                            ) : (<Autocomplete
                                disablePortal
                                options={voivodeshipsOptions}
                                getOptionLabel={(option) => option.name} // <--- POPRAWKA
                                value={voivodeshipsOptions.find(opt => opt.name === values.province) || null} // <--- POPRAWKA
                                onChange={(_, newValue) => { setVoivodeshipCode(newValue?.code); setFieldValue('province', newValue?.name || '') }} // <--- POPRAWKA
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={t('field.voivodeship')}
                                        name="province"
                                        onBlur={handleBlur}
                                        autoComplete="off"
                                        helperText={touched.province && errors.province}
                                        error={touched.province && Boolean(errors.province)}
                                    />
                                )}
                                sx={{ width: '100%' }}
                            />)}

                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            {values.province === '' ? (
                                <TextField
                                    fullWidth
                                    disabled
                                    label={t('field.county')}
                                    value=""
                                    helperText={t('field.selectVoivodeshipFirst')}
                                    placeholder={t('field.selectVoivodeshipFirst')}
                                />
                            ) : loadingCounties ? (
                                <Skeleton variant="rectangular" height={56} />
                            ) : (
                                <Autocomplete
                                    disablePortal
                                    options={countiesOptions}
                                    getOptionLabel={(option) => option.name}
                                    value={countiesOptions.find(opt => opt.name === values.district) || null}
                                    onChange={(_, newValue) => {
                                        setCountiesCode(newValue?.code);
                                        setFieldValue('district', newValue?.name || '')
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t('field.county')}
                                            name="district"
                                            autoComplete="off"
                                            onBlur={handleBlur}
                                            error={touched.district && Boolean(errors.district)}
                                            helperText={touched.district && errors.district}
                                        />
                                    )}
                                    sx={{ width: '100%' }}
                                />
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            {values.district === '' || values.province === '' ? (
                                <TextField
                                    fullWidth
                                    disabled
                                    label={t('field.municipality')}
                                    value=""
                                    helperText={values.province === '' ? t('field.selectVoivodeshipAndCountyFirst') : t('field.selectCountyFirst')}
                                    placeholder={t('field.selectVoivodeshipFirst')}
                                />
                            ) : loadingMunicipalities ? (
                                <Skeleton variant="rectangular" height={56} />
                            ) : (
                                <Autocomplete
                                    disablePortal
                                    options={municipalitiesOptions}
                                    getOptionLabel={(option) => option.name}
                                    value={municipalitiesOptions.find(opt => opt.name === values.commune) || null}
                                    onChange={(_, newValue) => {
                                        setFieldValue('commune', newValue?.name || '')
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={t('field.municipality')}
                                            autoComplete="off"
                                            name="commune"
                                            onBlur={handleBlur}
                                            error={touched.commune && Boolean(errors.commune)}
                                            helperText={touched.commune && errors.commune}
                                        />
                                    )}
                                    sx={{ width: '100%' }}
                                />
                            )}
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                fullWidth
                                label={t('field.city')}
                                placeholder={t('field.city')}
                                name="city"
                                value={values.city}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.city && Boolean(errors.city)}
                                helperText={touched.city && errors.city}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                fullWidth
                                label={t('field.postalCode')}
                                placeholder={t('field.postalCode')}
                                name="postalCode"
                                value={values.postalCode}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.postalCode && Boolean(errors.postalCode)}
                                helperText={touched.postalCode && errors.postalCode}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                fullWidth
                                label={t('field.street')}
                                placeholder={t('field.street')}
                                name="street"
                                value={values.street}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.street && Boolean(errors.street)}
                                helperText={touched.street && errors.street}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Grid container spacing={2}>
                                <Grid size={6}>
                                    <TextField
                                        fullWidth
                                        label={t('field.houseNumber')}
                                        placeholder={t('field.houseNumber')}
                                        name="houseNumber"
                                        value={values.houseNumber}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.houseNumber && Boolean(errors.houseNumber)}
                                        helperText={touched.houseNumber && errors.houseNumber}
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <TextField
                                        fullWidth
                                        label={t('field.apartmentNumber')}
                                        placeholder={t('field.apartmentNumber')}
                                        name="apartmentNumber"
                                        value={values.apartmentNumber}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.apartmentNumber && Boolean(errors.apartmentNumber)}
                                        helperText={touched.apartmentNumber && errors.apartmentNumber}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default ContactData;
